// extracted by mini-css-extract-plugin
export default {"section":"Index_section__gDp2X","productWrap":"Index_productWrap__Lp74v","firstWrap":"Index_firstWrap__NZn1g","imgWrap":"Index_imgWrap__Makoq"};